import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Sparkles, Activity, Shield, BookOpen, ArrowRight } from 'lucide-react';

const CONTENT = {
  it: {
    title: 'Più di una eSIM',
    subtitle: 'Strumenti esclusivi per viaggiare smart',
    cta: 'Scopri i Piani',
    features: [
      { icon: Sparkles, title: 'Assistente AI 24/7', desc: 'Il tuo consulente di viaggio personale. Consigli su destinazioni, piani dati e sicurezza — in tempo reale, nella tua lingua.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Monitor Dati Smart', desc: 'Controlla il consumo dati in tempo reale. Alert automatici all\'80% e 95% per non restare mai senza connessione.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Avvisi Sicurezza Viaggio', desc: 'Informazioni di sicurezza generate dall\'AI per ogni destinazione. Numeri di emergenza, consigli sanitari e alert.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Diario di Viaggio', desc: 'Registra e condividi i tuoi ricordi. Scrivi, aggiungi foto e il tuo stato d\'animo — poi condividi con chi vuoi.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
  en: {
    title: 'More Than an eSIM',
    subtitle: 'Exclusive tools for smart travel',
    cta: 'Explore Plans',
    features: [
      { icon: Sparkles, title: 'AI Assistant 24/7', desc: 'Your personal travel consultant. Tips on destinations, data plans and safety — real-time, in your language.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Smart Data Monitor', desc: 'Track data usage in real time. Automatic alerts at 80% and 95% so you never lose connection.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Travel Safety Alerts', desc: 'AI-generated safety info for every destination. Emergency numbers, health tips and alerts.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Travel Diary', desc: 'Record and share your memories. Write, add photos and mood — then share with anyone.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
  pl: {
    title: 'Więcej niż eSIM',
    subtitle: 'Ekskluzywne narzędzia podróżne',
    cta: 'Zobacz Plany',
    features: [
      { icon: Sparkles, title: 'Asystent AI 24/7', desc: 'Twój osobisty doradca podróżny. Porady o destynacjach, planach danych i bezpieczeństwie.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Monitor Danych', desc: 'Śledź zużycie danych w czasie rzeczywistym. Automatyczne alerty przy 80% i 95%.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Alerty Bezpieczeństwa', desc: 'Informacje bezpieczeństwa generowane przez AI dla każdej destynacji.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Dziennik Podróży', desc: 'Zapisuj i udostępniaj wspomnienia. Pisz, dodawaj zdjęcia i nastrój.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
  fr: {
    title: 'Plus qu\'une eSIM',
    subtitle: 'Outils exclusifs pour voyager smart',
    cta: 'Voir les Forfaits',
    features: [
      { icon: Sparkles, title: 'Assistant IA 24/7', desc: 'Votre conseiller voyage personnel. Conseils sur les destinations, forfaits et sécurité.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Moniteur de Données', desc: 'Suivez votre consommation en temps réel. Alertes automatiques à 80% et 95%.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Alertes Sécurité', desc: 'Infos sécurité générées par IA pour chaque destination.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Journal de Voyage', desc: 'Enregistrez et partagez vos souvenirs. Écrivez, ajoutez des photos.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
  es: {
    title: 'Más que una eSIM',
    subtitle: 'Herramientas exclusivas para viajar smart',
    cta: 'Ver Planes',
    features: [
      { icon: Sparkles, title: 'Asistente IA 24/7', desc: 'Tu consultor de viaje personal. Consejos sobre destinos, planes de datos y seguridad.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Monitor de Datos', desc: 'Controla tu consumo en tiempo real. Alertas automáticas al 80% y 95%.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Alertas de Seguridad', desc: 'Info de seguridad generada por IA para cada destino.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Diario de Viaje', desc: 'Registra y comparte tus recuerdos. Escribe, añade fotos y estado de ánimo.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
  de: {
    title: 'Mehr als eine eSIM',
    subtitle: 'Exklusive Tools für smartes Reisen',
    cta: 'Pläne Entdecken',
    features: [
      { icon: Sparkles, title: 'KI-Assistent 24/7', desc: 'Ihr persönlicher Reiseberater. Tipps zu Zielen, Datenplänen und Sicherheit.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Daten-Monitor', desc: 'Datenverbrauch in Echtzeit verfolgen. Automatische Warnungen bei 80% und 95%.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Sicherheitshinweise', desc: 'KI-generierte Sicherheitsinfos für jedes Reiseziel.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Reisetagebuch', desc: 'Erinnerungen festhalten und teilen. Schreiben, Fotos und Stimmung hinzufügen.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
  ru: {
    title: 'Больше, чем eSIM',
    subtitle: 'Эксклюзивные инструменты для путешествий',
    cta: 'Смотреть Планы',
    features: [
      { icon: Sparkles, title: 'ИИ-ассистент 24/7', desc: 'Ваш личный консультант. Советы по направлениям, тарифам и безопасности.', gradient: 'from-violet-500 to-fuchsia-500', glow: 'shadow-violet-500/20' },
      { icon: Activity, title: 'Монитор данных', desc: 'Отслеживайте потребление данных в реальном времени. Автоуведомления на 80% и 95%.', gradient: 'from-teal-500 to-cyan-500', glow: 'shadow-teal-500/20' },
      { icon: Shield, title: 'Безопасность', desc: 'ИИ-информация о безопасности для каждого направления.', gradient: 'from-amber-500 to-orange-500', glow: 'shadow-amber-500/20' },
      { icon: BookOpen, title: 'Дневник путешествий', desc: 'Записывайте и делитесь воспоминаниями. Фото, текст и настроение.', gradient: 'from-rose-500 to-pink-500', glow: 'shadow-rose-500/20' },
    ]
  },
};

export default function WhyeSIM4You({ onNavigate }) {
  const { i18n } = useTranslation();
  const lang = CONTENT[i18n.language] ? i18n.language : 'en';
  const c = CONTENT[lang];

  return (
    <section className="py-24 bg-[#0f1419] relative overflow-hidden" data-testid="why-esim4you">
      {/* Subtle background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal-500/[0.03] rounded-full blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest uppercase text-teal-400 mb-4 px-3 py-1 rounded-full bg-teal-500/10 border border-teal-500/20">
            <Sparkles className="w-3.5 h-3.5" /> Exclusive
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-outfit mb-4">
            {c.title}
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-xl mx-auto">
            {c.subtitle}
          </p>
        </motion.div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {c.features.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className={`group relative bg-white/[0.03] border border-white/[0.06] rounded-2xl p-6 hover:bg-white/[0.06] transition-all duration-300 hover:shadow-lg ${f.glow} hover:border-white/[0.12]`}
              data-testid={`why-feature-${i}`}
            >
              <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${f.gradient} flex items-center justify-center mb-5 shadow-lg ${f.glow} group-hover:scale-110 transition-transform duration-300`}>
                <f.icon className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-white font-semibold text-base mb-2 font-outfit">{f.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-14"
        >
          <button
            onClick={() => onNavigate('shop')}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-teal-400 hover:from-teal-400 hover:to-teal-300 text-black font-bold px-8 py-3.5 rounded-full transition-all duration-200 shadow-lg shadow-teal-500/25 hover:shadow-teal-500/40 hover:scale-[1.02]"
            data-testid="why-cta-btn"
          >
            {c.cta} <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
